import { Button, Heading, IconButton } from '@assembly-js/design-system';
import React, { useContext } from 'react';

import { ContractBuilderContext } from 'src/context/contractBuilderContext';

interface ContractBuilderModalHeaderProps {
  onCancel: () => void;
  handleSubmit: () => void;
  isSubmitting?: boolean;
}

export const ContractBuilderModalHeader: React.FC<
  ContractBuilderModalHeaderProps
> = ({ onCancel, handleSubmit, isSubmitting = false }) => {
  const { isOneOffContract } = useContext(ContractBuilderContext);

  const actionLabel = isOneOffContract ? 'Send' : 'Create template';

  return (
    <div className="sticky top-0 z-10 flex items-center justify-between border-b border-solid border-x-0 border-t-0 border-non-hover-border bg-white px-4 sm:px-6 py-4 h-15">
      <div className="flex shrink-0 items-center gap-2 sm:gap-3 overflow-hidden pr-4">
        <IconButton
          icon="Close"
          onClick={onCancel}
          label="Close"
          variant="minimal"
          className="text-black-heading"
          size="sm"
        />
        <div className="border border-solid border-y-0 border-t-0 border-non-hover-border h-5 hidden sm:block" />
        <Heading className="text-sm sm:text-lg text-black-heading">
          Create contract
        </Heading>
      </div>

      <div className="flex items-center gap-2.5">
        <Button
          label="Cancel"
          variant="secondary"
          onClick={onCancel}
          size="sm"
        />
        <Button
          label={actionLabel}
          variant="primary"
          onClick={handleSubmit}
          loading={isSubmitting}
          size="sm"
          type="submit"
        />
      </div>
    </div>
  );
};
